const UPDATE_EVENT = 'pmflow:client-update-required';
const HASHED_MAIN_ASSET = /^\/static\/(?:js|css)\/main\.[a-f0-9]{8}\.(?:js|css)$/i;

let updateRequired = false;

export function buildSignature(doc: Document): string {
  return Array.from(doc.querySelectorAll('script[src], link[rel="stylesheet"][href]'))
    .map((node) => node.getAttribute('src') || node.getAttribute('href'))
    .filter((url): url is string => Boolean(url))
    .map((url) => {
      try {
        return new URL(url, window.location.origin).pathname;
      } catch {
        return '';
      }
    })
    .filter((pathname) => HASHED_MAIN_ASSET.test(pathname))
    .sort()
    .join('|');
}

export function isClientUpdateRequired(): boolean {
  return updateRequired;
}

export async function checkClientVersion(): Promise<boolean> {
  if (updateRequired) return false;
  const runningVersion = buildSignature(document);
  // CRA's development server has no hashed build assets.
  if (!runningVersion) return true;

  try {
    const response = await fetch(`/index.html?pmflow-version-check=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    });
    if (!response.ok || !response.headers.get('content-type')?.includes('text/html')) {
      return true;
    }
    const latest = new DOMParser().parseFromString(await response.text(), 'text/html');
    const newestVersion = buildSignature(latest);
    if (newestVersion && newestVersion !== runningVersion) {
      updateRequired = true;
      window.dispatchEvent(new Event(UPDATE_EVENT));
      return false;
    }
  } catch {
    // A temporary network failure must not prevent a valid submission.
  }
  return true;
}

export { UPDATE_EVENT };
